import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

const styles = ({ theme }) => {
  return {
    root: {
      padding: [0, '18px'],
      [`@media (min-width: ${theme.screens.md}px)`]: {
        padding: [0, '24px']
      },
      [`@media (min-width: ${theme.screens.lg}px)`]: {
        padding: [0, '48px']
      }
    }
  };
};
const ViewportPadding = ({ classes, children }) => {
  return <div className={classes.root}>{children}</div>;
};

ViewportPadding.propTypes = {
  children: PropTypes.node
};

export default injectSheet(styles)(ViewportPadding);
